import { browserHistory } from 'react-router'
import { scoreViewDispatch } from '../reducers/container/scoreDispatch'
import * as firebase from 'firebase'

export function scoreViewAction(gameKeyClone) {
    return dispatch => {
        // console.log('gameKeyClone', gameKeyClone);
        let resultObject = {
            quizName: gameKeyClone.quizTitle,
            playedOn: Date.now(),
            played: gameKeyClone.currentQuizIndex + 1,
            players: gameKeyClone.players,
            gameType: gameKeyClone.type,
            challengeKey: gameKeyClone.key,
            generatorId: gameKeyClone.generatorId
        }
        // console.log('resultObject', resultObject);
        for (var key in resultObject.players) {
            if ('result' in resultObject.players[key] === false) {
                resultObject.players[key].result = { correctAnswers: 0, score: 0 }
            }
        }
        // for (var i = 0; i < resultObject.players.length; i++) {
        //     if('result' in resultObject.players[i] === false){
        //         resultObject.players[i].result = {correctAnswers: 0, score: 0}
        //     }
        // }

        firebase.database().ref('/result/' + gameKeyClone.type.toLowerCase()  + '/' + gameKeyClone.key + resultObject.playedOn + '/').push(resultObject);

        firebase.database().ref('/gameRom/' + gameKeyClone.key + '/').set(gameKeyClone);
        firebase.database().ref('/gameRom/' + gameKeyClone.key + '/').child('players').once('value', (obj) => {
            let score = obj.val();
            if (score !== null) {
                dispatch(scoreViewDispatch(score))
                browserHistory.push('/viewscore');
            }
            else {
                dispatch(scoreViewDispatch({}))
                alert('Appliction is turn off')
            }
        })

    }
}


// WEBPACK FOOTER //
// ./src/action/scoresAction.jsx